import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/'
import store from './store'
import config from './config/'
import organization from "@/config/organization";

// Helper function to check if the user's profile is incomplete
function isProfileIncomplete(user, organization) {
    const isBasicInfoMissing =  !user.name || user.name === '' || user.disabled;
    const isMobileMissing = (!user.mobile || user.mobile === '') && organization.mobile_required;
    const isEmailMissing = (!user.email || user.email === '') && organization.email_required;
    return isBasicInfoMissing || isMobileMissing || isEmailMissing;
}

// Helper function to check if creating a meeting is forbidden
function isCreateMeetingForbidden(to, preset, user) {
    return to.name === "新建会议" &&
        preset.app &&
        preset.app.create_meeting_forbidden &&
        user.role_level < 3;
}

function handleCreateMeetingForbidden(preset) {
    if (preset.app.create_meeting_forbidden_redirect) {
        window.location.href = preset.app.create_meeting_forbidden_redirect;
    } else {
        Vue.prototype.$notice.error(preset.app.create_meeting_forbidden_message);
    }
}

// Helper function: Check if token is valid
function isTokenValid(user) {
    const currentTime = new Date().getTime();
    return user.token && (currentTime - user.time) / 1000 < 3600;
}

// Helper function: Check if user has access to the route
function hasAccessToRoute(to, roleLevel) {
    return to.matched.every(route => {
        if (route.meta && route.meta.level) {
            return route.meta.level.includes(roleLevel);
        }
        return true;
    });
}

// Helper function: Handle unauthorized access
function handleUnauthorized(next) {
    next({ path: '/' });
}

// Helper function: Redirect to sign-in
function redirectToSignIn(to, next) {
    next({ name: 'sign-in', query: { _t: encodeURIComponent(to.path) } });
}

// Router Hook
router.beforeEach((to, from, next) => {
    const user = store.getters['user/user'];
    const preset = store.state.preset;
    const roleLevel = parseInt(user.role_level);

    // Public routes
    if (to.meta && to.meta.public) {
        return next();
    }

    // Check token validity
    if (!isTokenValid(user)) {
        return redirectToSignIn(to, next);
    }

    // Check role-level access
    if (!hasAccessToRoute(to, roleLevel)) {
        return handleUnauthorized(next);
    }

    // Additional logic for specific routes
    if (to.name !== "我的档案" && isProfileIncomplete(user, organization)) {
        next({ path: '/profile' });
    } else if (isCreateMeetingForbidden(to, preset, user)) {
        handleCreateMeetingForbidden(preset);
    } else {
        next();
    }
});


router.afterEach(() => {
});

Vue.config.productionTip = false;
Vue.prototype.$organization = config.org;

//const app =
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

//load preset
/*
app.$api('User.Preset',{},1).then(res=>{
    store.commit('preset/set',res.data.data);
});
*/

store.dispatch('preset/loadPreset');


